import {Action, createReducer, on} from '@ngrx/store';
import * as AuthActions from '../actions/auth.actions';

import {AUTH_CODE, AUTH_TOKEN} from '../../consts';
import {User, USER_TYPE} from '../../../../core/models/models';


export const authFeatureKey = 'auth';

export interface State {
  loading: boolean;
  error?: string;
  user?: User;
  token?: string | null;
  code?: string | null;
  user_type?: string;
}

export const initialState: State = {
  loading: false,
  token: localStorage.getItem(AUTH_TOKEN),
  error: ''
};


export const reducer = createReducer(
  initialState,

  on(AuthActions.login, state => ({...state, loading: true})),
  on(AuthActions.loginBySmsCode, state => ({...state, loading: true})),
  on(AuthActions.loginUserBySmsCode, state => ({...state, loading: true})),
  on(AuthActions.loginByAuthCode, (state, action) => {
    localStorage.setItem(AUTH_CODE, action.auth_code);
    return {...state, code: action.auth_code};
  }),
  on(AuthActions.setUserType, (state, action) => ({...state, user_type: action.user_type.toUpperCase()})),
  on(AuthActions.registerUser, (state, action) => ({...state, loading: true})),
  on(AuthActions.registerFinish, (state, action) => ({...state, loading: false})),
  on(AuthActions.setToken, (state, action) => {
    if (action.token) {
      localStorage.setItem(AUTH_TOKEN, action.token);
    }
    return {...state, token: action.token};
  }),
  on(AuthActions.updateUserInfo, (state, action) => {
    return {...state, user: action.user};
  }),
  on(AuthActions.loginSuccess, (state, action) => {
    const rawUserInfo = localStorage.getItem(AUTH_TOKEN)?.split('.')[1] || '';

    let routes: string[] | undefined;
    switch (action.user?.userType) {
      case USER_TYPE.LUMIIADMIN:
        routes = ['/admin/chats', '/admin/schools', '/admin/mats', '/admin/resources'];
        break;
      case USER_TYPE.SCHOOL:
        routes = ['/admin/chats', '/admin/schools', '/admin/resources'];
        break;
    }

    const user = {...action.user, routes};

   // const user_type = Base64Decode.b64ToObject(rawUserInfo)?.user_type;
//    const user = {...action.user, user_type: JSON.parse(atob(localStorage.getItem(AUTH_TOKEN)?.split('.')[1] || ''))?.user_type}
    // const user = {...action.user, user_type}
    return {...state, user, loading: false};
  }),
  on(AuthActions.logout, (state, action) => {
    return {...state, user: undefined};
  }),
  on(AuthActions.authError, (state, action) => {
    return {...state, error: action.error, loading: false};
  }),
  on(AuthActions.checkCode, AuthActions.resendCode, (state, action) => {
    return {...state, loading: true};
  }),
  on(AuthActions.checkCodeSuccess, AuthActions.resendCodeSuccess, (state, action) => {
    return {...state, loading: false};
  }),
);

